import { HashLink as Link } from "react-router-hash-link";
import { FaInstagram, FaGithub, FaTiktok } from "react-icons/fa";
import Form from "../components/form";
import noscrollOffset from "../components/noscrollOffset";
import { FaXTwitter } from "react-icons/fa6";
import scrollToTop from "../components/scroll-to-top";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-toprow">
        <div className="footer-intro">
          <Link
            to="/"
            onClick={() => {
              scrollToTop();
            }}
          >
            <img
              src="https://dye493vmtifvj.cloudfront.net/aws-logos/full/fullwhitelogo1.webp"
              alt="whitelogo"
            />
          </Link>
          <div className="footer-text">
            <h4>Who we are</h4>
            <p>
              Acrylic Web Studios is a creative web design and development
              agency dedicated to building modern, high-performing websites. We
              help businesses stand out online with custom design, seamless
              functionality, and reliable hosting and maintenance. Our mission
              is to make your digital presence effortless, effective,
              and uniquely yours.
            </p>
          </div>
        </div>
        <div className="footer-main">
          <div className="footer-link-section-container">
            <div className="footer-link-section">
              <h4>Browse</h4>
              <div className="footer-link-container">
                <Link
                  to="/"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Home
                </Link>
                <Link
                  to="/about"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  About us
                </Link>
                <Link
                  to="/services"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Services
                </Link>
                <Link
                  to="/projects"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Projects
                </Link>
                <Link
                  to="/contact"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Contact
                </Link>
              </div>
            </div>
            <div className="footer-link-section">
              {" "}
              <h4>Useful links</h4>
              <div className="footer-link-container">
                <Link
                  to="/intro-form"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  I need a website
                </Link>
                <Link
                  to="/feedback-form"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Feedback form
                </Link>

                <Link to="/services#lp-faq" scroll={noscrollOffset}>
                  FAQs
                </Link>
                <Link
                  to="/services/link-in-bio"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Custom Link in Bio Pages
                </Link>
              </div>
            </div>
            <div className="footer-link-section">
              {" "}
              <h4>Services</h4>
              <div className="footer-link-container">
                <Link
                  to="/design"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Design
                </Link>
                <Link
                  to="/development"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Development
                </Link>
                <Link
                  to="/hosting-maintenance"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Hosting & Maintenance
                </Link>
                <Link
                  to="/consulting"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Consulting
                </Link>
                <Link
                  to="/landing-more"
                  onClick={() => {
                    scrollToTop();
                  }}
                >
                  Landing Pages & More
                </Link>
              </div>
            </div>
          </div>
          <div className="mailing-list-curve">
            <div className="mailing-list">
              <Form formid="mailinglist" />
            </div>
            <div className="footer-sm">
              <h4>Follow us</h4>
              <div className="sm-icon-container">
                {/*<FaLinkedin className="icon" />*/}{" "}
                <a href="https://www.tiktok.com/@acrylicwebstudios_?_t=ZN-8yjzXsUZC8k&_r=1">
                  <FaTiktok className="icon" />
                </a>
                <a href="https://x.com/AcrylicWeb?t=TvG8qFsvWTvSGsBhsQXFew&s=08">
                  <FaXTwitter className="icon" />
                </a>
                <a href="https://github.com/acrylicweb">
                  {" "}
                  <FaGithub className="icon" />
                </a>{" "}
                <a href="https://www.instagram.com/acrylicwebstudios?igsh=MXRtbXJvbjV0Y29kdA%3D%3D&utm_source=qr">
                  {" "}
                  <FaInstagram className="icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <img
          className="lines"
          src="https://d1cj3qoxnek6r9.cloudfront.net/design-system/Group151.webp"
          alt="lines"
        />
      </div>

      <hr className="footerline" />
      <span className="footer-bottom">
        ©2024 Acrylic web studios - all rights reserved
      </span>
    </div>
  );
};

export default Footer;
